import { documentSignsService } from '@/services/documentsigns.service';
import { SignMethod } from '@/sign/models/sign-constants';
import { SignDocumentPrivateKeyStrategy } from './sign-document-private-key.strategy';
import { MixWithDepositSignLoginPswDocumentSigning } from '@/sign/mixins/deposit-sign.mixin';
import { MixWithDiiaDocumentSigning } from '@/sign/mixins/diia-sign.mixin';
import { MixWithCloudKeyFileSystemDocumentSigning } from '../mixins/cloud-key-sign.mixin';
import { unregUserDocService } from '@/services/unregistered-user-document.service';
import { isUnregUserView } from '@/helpers/ui-helper';
import { MixWithDefaultAppConfirmationDocumentSigning, MixWithDefaultQrCodeDocumentSigning } from '@/sign/mixins/general-sign.mixin';

abstract class ContragentSignDocumentSignPrivateKeyStrategy
  extends SignDocumentPrivateKeyStrategy {
  private readonly documentSignUserId: number;

  constructor(prms: any) {
    super(prms);
    this.documentSignUserId = prms.documentSignUserId;
  }

  protected async validate(): Promise<void> {
    await super.validate();
    if (!this.documentSignUserId) {
      throw new Error('Document sign user id is not defined');
    }
  }

  protected async getHashes(): Promise<any> {
    if (isUnregUserView()) {
      return unregUserDocService.getHashesForSigningByCounterparty(this.documentVersionCode, this.keyType);
    } else {
      return documentSignsService.getHashesForSigningByCounterparty(this.documentVersionCode, this.keyType);
    }
  }
}

export class ContragentSignDocumentSignFileSystemStrategy
  extends ContragentSignDocumentSignPrivateKeyStrategy {
  protected signMethod?: SignMethod = SignMethod.FileSystem;
}

export class ContragentSignDocumentSignDeviceStrategy
  extends ContragentSignDocumentSignPrivateKeyStrategy {
  protected signMethod?: SignMethod = SignMethod.Device;
}

export class ContragentSignDocumentSignCloudStrategy
  extends ContragentSignDocumentSignPrivateKeyStrategy {
  protected signMethod?: SignMethod = SignMethod.Cloud;

  constructor(prms: any) {
    super(prms);

    this.mobileAppName = prms?.mobileAppName;
  }
}

export class ContragentSignDocumentSignDepositSignLoginPswStrategy
  extends MixWithDepositSignLoginPswDocumentSigning(ContragentSignDocumentSignCloudStrategy) {
}

export class ContragentSignDocumentSignDiiaStrategy
  extends MixWithDiiaDocumentSigning(ContragentSignDocumentSignCloudStrategy) {
}

export class ContragentSignDocumentSignCloudKeyFileSystemStrategy
  extends MixWithCloudKeyFileSystemDocumentSigning(ContragentSignDocumentSignCloudStrategy) {
}

export class ContragentSignDocumentSignWithQrCloudProviderStrategy
  extends MixWithDefaultQrCodeDocumentSigning(ContragentSignDocumentSignCloudStrategy) {
}

export class ContragentSignDocumentSignWithIdCloudProviderStrategy
  extends MixWithDefaultAppConfirmationDocumentSigning(ContragentSignDocumentSignCloudStrategy) {
}
